import { useState, useEffect, useCallback } from 'react';
import { get, post, put, del } from '../api';
import SearchableSelect from './SearchableSelect';

const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const ROLE_ORDER = ['Host', 'Axe Coach', 'Lucky Putt', 'Server', 'Runner', 'Busser', 'Bartender', 'Barback', 'Breaker'];

function orderRoles(roles) {
  var inOrder = ROLE_ORDER.filter(function (r) { return roles.indexOf(r) !== -1; });
  var extras = roles.filter(function (r) { return ROLE_ORDER.indexOf(r) === -1; }).sort();
  return inOrder.concat(extras);
}
function pad(n) { return (n < 10 ? '0' : '') + n; }
function mondayOf(d) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); var day = x.getDay(); var diff = (day === 0 ? -6 : 1 - day); x.setDate(x.getDate() + diff); return x; }
function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
function fmtDay(d) { return (d.getMonth() + 1) + '/' + d.getDate(); }
function fmtTime(t) {
  if (!t) return '';
  var parts = ('' + t).split(':'); var h = parseInt(parts[0], 10); var m = parts[1] || '00';
  if (isNaN(h)) return t;
  var ap = h >= 12 ? 'p' : 'a'; var h12 = h % 12; if (h12 === 0) h12 = 12;
  return h12 + (m === '00' ? '' : ':' + m) + ap;
}

var inputStyle = { width: '100%', background: '#2a1f0f', border: '1px solid #3a2a12', borderRadius: 8, padding: '10px 12px', color: '#f5e6c8', fontSize: 14, boxSizing: 'border-box', fontFamily: 'inherit' };

// Authed CSV download (the shared api() helper is JSON-only).
async function exportScheduleCsv(week) {
  var token = localStorage.getItem('tnt_token');
  try {
    var res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/schedule/export' + (week ? '?week=' + week : ''), { headers: token ? { Authorization: 'Bearer ' + token } : {} });
    if (!res.ok) return;
    var m = (res.headers.get('Content-Disposition') || '').match(/filename="?([^"]+)"?/);
    var url = URL.createObjectURL(await res.blob());
    var a = document.createElement('a');
    a.href = url; a.download = (m && m[1]) || 'schedule.csv';
    document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
  } catch (e) { /* ignore */ }
}

var STAGE_COLOR = { new_applicant: '#6366f1', reviewing: '#06b6d4', interview: '#f59e0b', offer: '#a855f7', hired: '#10b981', not_moving: '#e63c3c', saved_for_later: '#8a7055' };
var STAGE_LABEL = { new_applicant: 'New', reviewing: 'Reviewing', interview: 'Interview', offer: 'Offer', hired: 'Hired', not_moving: 'Not Moving', saved_for_later: 'Saved' };
function stageColor(s) { return STAGE_COLOR[s] || '#8a7055'; }
function stageLabel(s) { return STAGE_LABEL[s] || s || '—'; }
function fmtStamp(s) {
  if (!s) return '';
  var d = new Date(('' + s).replace(' ', 'T'));
  if (isNaN(d.getTime())) return s;
  return (d.getMonth() + 1) + '/' + d.getDate() + '/' + String(d.getFullYear()).slice(2);
}

function Btn({ onClick, children, variant = 'primary', small, disabled }) {
  const s = { primary: { background: '#c9a96e', color: '#1a1208', border: 'none' }, secondary: { background: 'transparent', color: '#8a7055', border: '1px solid #3a2a12' }, danger: { background: '#e63c3c22', color: '#e63c3c', border: '1px solid #e63c3c44' }, ghost: { background: '#c9a96e18', color: '#c9a96e', border: '1px solid #c9a96e44' } };
  return <button onClick={onClick} disabled={disabled} style={{ ...s[variant], borderRadius: 8, padding: small ? '6px 12px' : '10px 20px', fontWeight: 700, cursor: disabled ? 'default' : 'pointer', fontSize: small ? 12 : 14, opacity: disabled ? 0.5 : 1, fontFamily: 'inherit' }}>{children}</button>;
}
function Lbl({ children }) { return <label style={{ display: 'block', color: '#8a7055', fontSize: 11, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{children}</label>; }
function Modal({ children, onClose }) {
  return (<div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }} onClick={onClose}><div style={{ background: '#1a1208', border: '1px solid #3a2a12', borderRadius: 14, padding: 26, maxWidth: 460, width: '100%', maxHeight: '92vh', overflowY: 'auto' }} onClick={function (e) { e.stopPropagation(); }}>{children}</div></div>);
}

function TargetsTab() {
  const [map, setMap] = useState({});
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState('');

  const load = useCallback(async function () {
    try {
      const rows = await get('/schedule/targets');
      var m = {}; var rset = {};
      (rows || []).forEach(function (r) { m[r.role + '|' + r.day_of_week] = r.target; rset[r.role] = true; });
      setMap(m); setRoles(orderRoles(Object.keys(rset)));
    } catch (e) { console.error(e); } finally { setLoading(false); }
  }, []);
  useEffect(function () { load(); }, [load]);

  function edit(role, di, v) {
    var key = role + '|' + di;
    setMap(function (p) { var x = Object.assign({}, p); x[key] = (v === '' ? '' : Math.max(0, parseInt(v, 10) || 0)); return x; });
  }
  async function commit(role, di) {
    var key = role + '|' + di;
    var n = parseInt(map[key], 10); if (isNaN(n) || n < 0) n = 0;
    setMap(function (p) { var x = Object.assign({}, p); x[key] = n; return x; });
    setSaving(key);
    try { await put('/schedule/targets', { role: role, day_of_week: di, target: n }); }
    catch (e) { console.error(e); } finally { setSaving(''); }
  }

  if (loading) return <p style={{ color: '#5a4030' }}>Loading...</p>;
  var dayTotals = DAYS.map(function (_, di) { return roles.reduce(function (sum, r) { return sum + (parseInt(map[r + '|' + di], 10) || 0); }, 0); });

  return (
    <div>
      <p style={{ color: '#8a7055', marginBottom: 16 }}>Peak coverage targets - how many of each role you want on the floor each day. These drive the coverage check on the weekly schedule.</p>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 620 }}>
          <thead><tr>
            <th style={{ textAlign: 'left', padding: '8px 12px', color: '#c9a96e', fontSize: 12, borderBottom: '1px solid #3a2a12' }}>Role</th>
            {DAYS.map(function (d) { return <th key={d} style={{ padding: '8px 6px', color: '#c9a96e', fontSize: 12, borderBottom: '1px solid #3a2a12', width: 64 }}>{d}</th>; })}
            <th style={{ padding: '8px 6px', color: '#8a7055', fontSize: 12, borderBottom: '1px solid #3a2a12' }}>Total</th>
          </tr></thead>
          <tbody>
            {roles.map(function (role) {
              var rowTotal = DAYS.reduce(function (s, _, di) { return s + (parseInt(map[role + '|' + di], 10) || 0); }, 0);
              return (<tr key={role}>
                <td style={{ padding: '6px 12px', color: '#f5e6c8', fontSize: 14, fontWeight: 600, borderBottom: '1px solid #241a0c' }}>{role}</td>
                {DAYS.map(function (d, di) {
                  var key = role + '|' + di;
                  return <td key={d} style={{ padding: 4, borderBottom: '1px solid #241a0c', textAlign: 'center' }}>
                    <input type="number" min="0" value={map[key] == null ? '' : map[key]} onChange={function (e) { edit(role, di, e.target.value); }} onBlur={function () { commit(role, di); }} style={{ width: 46, textAlign: 'center', background: saving === key ? '#3a2a12' : '#2a1f0f', border: '1px solid #3a2a12', borderRadius: 6, padding: '6px 4px', color: '#f5e6c8', fontSize: 14, fontFamily: 'inherit' }} />
                  </td>;
                })}
                <td style={{ padding: '6px', textAlign: 'center', color: '#8a7055', fontSize: 13, borderBottom: '1px solid #241a0c' }}>{rowTotal}</td>
              </tr>);
            })}
            <tr>
              <td style={{ padding: '8px 12px', color: '#c9a96e', fontSize: 13, fontWeight: 700 }}>Total / day</td>
              {dayTotals.map(function (t, i) { return <td key={i} style={{ padding: '8px 6px', textAlign: 'center', color: '#c9a96e', fontSize: 14, fontWeight: 700 }}>{t}</td>; })}
              <td style={{ padding: '8px 6px', textAlign: 'center', color: '#c9a96e', fontSize: 14, fontWeight: 700 }}>{dayTotals.reduce(function (a, b) { return a + b; }, 0)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ShiftModal({ shift, users, roles, weekStart, dayIndex, onClose, onSaved }) {
  const isNew = !shift;
  const [form, setForm] = useState(shift
    ? { user_id: shift.user_id, job: shift.job || (roles[0] || ''), start_time: shift.start_time || '17:00', end_time: shift.end_time || '22:00', day_of_week: shift.day_of_week }
    : { user_id: (users[0] && users[0].id) || '', job: (roles[0] || ''), start_time: '17:00', end_time: '22:00', day_of_week: dayIndex });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  function set(k, v) { setForm(function (p) { var n = Object.assign({}, p); n[k] = v; return n; }); }

  async function save() {
    if (!form.user_id) { setError('Pick a staff member'); return; }
    setSaving(true); setError('');
    var body = { user_id: form.user_id, position_id: null, job: form.job, week_start: weekStart, day_of_week: form.day_of_week, start_time: form.start_time, end_time: form.end_time };
    try {
      if (isNew) await post('/schedule/shifts', body);
      else await put('/schedule/shifts/' + shift.id, body);
      onSaved(); onClose();
    } catch (e) { setError(e.message); setSaving(false); }
  }
  async function remove() {
    setSaving(true);
    try { await del('/schedule/shifts/' + shift.id); onSaved(); onClose(); }
    catch (e) { setError(e.message); setSaving(false); }
  }

  return (
    <Modal onClose={onClose}>
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, color: '#f5e6c8', marginBottom: 16 }}>{isNew ? 'Add Shift' : 'Edit Shift'}</h2>
      <div style={{ marginBottom: 12 }}><Lbl>Staff</Lbl>
        <SearchableSelect
          value={form.user_id}
          onChange={function (v) { set('user_id', v); }}
          options={users.map(function (u) { return { value: u.id, label: u.name }; })}
          placeholder="Choose staff member…"
        />
      </div>
      <div style={{ marginBottom: 12 }}><Lbl>Role</Lbl>
        <select value={form.job} onChange={function (e) { set('job', e.target.value); }} style={inputStyle}>
          {roles.map(function (r) { return <option key={r} value={r}>{r}</option>; })}
        </select>
      </div>
      <div style={{ marginBottom: 12 }}><Lbl>Day</Lbl>
        <select value={form.day_of_week} onChange={function (e) { set('day_of_week', parseInt(e.target.value, 10)); }} style={inputStyle}>
          {DAYS.map(function (d, i) { return <option key={d} value={i}>{d}</option>; })}
        </select>
      </div>
      <div style={{ display: 'flex', gap: 12 }}>
        <div style={{ flex: 1 }}><Lbl>Start</Lbl><input type="time" value={form.start_time} onChange={function (e) { set('start_time', e.target.value); }} style={inputStyle} /></div>
        <div style={{ flex: 1 }}><Lbl>End</Lbl><input type="time" value={form.end_time} onChange={function (e) { set('end_time', e.target.value); }} style={inputStyle} /></div>
      </div>
      {error && <p style={{ color: '#e63c3c', fontSize: 13, marginTop: 10 }}>{error}</p>}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 18 }}>
        <div>{!isNew && <Btn variant="danger" onClick={remove} disabled={saving}>Delete</Btn>}</div>
        <div style={{ display: 'flex', gap: 10 }}>
          <Btn variant="secondary" onClick={onClose}>Cancel</Btn>
          <Btn onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Save'}</Btn>
        </div>
      </div>
    </Modal>
  );
}

function ShiftsTab({ users, roles, targetsByDay }) {
  const [weekStart, setWeekStart] = useState(ymd(mondayOf(new Date())));
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);

  const load = useCallback(async function () {
    setLoading(true);
    try { const rows = await get('/schedule/shifts?week=' + weekStart); setShifts(Array.isArray(rows) ? rows : []); }
    catch (e) { console.error(e); } finally { setLoading(false); }
  }, [weekStart]);
  useEffect(function () { load(); }, [load]);

  function shiftWeek(delta) { var d = new Date(weekStart + 'T00:00:00'); d.setDate(d.getDate() + delta * 7); setWeekStart(ymd(d)); }
  function userName(id) { var u = users.find(function (x) { return x.id === id; }); return u ? u.name : 'Unknown'; }
  var monday = new Date(weekStart + 'T00:00:00');

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18, flexWrap: 'wrap' }}>
        <Btn small variant="secondary" onClick={function () { shiftWeek(-1); }}>&lt; Prev</Btn>
        <span style={{ color: '#f5e6c8', fontWeight: 600 }}>Week of {fmtDay(monday)} - {fmtDay(addDays(monday, 6))}</span>
        <Btn small variant="secondary" onClick={function () { shiftWeek(1); }}>Next &gt;</Btn>
        <Btn small variant="ghost" onClick={function () { setWeekStart(ymd(mondayOf(new Date()))); }}>This week</Btn>
        <div style={{ marginLeft: 'auto' }}>
          <Btn small variant="secondary" onClick={function () { exportScheduleCsv(weekStart); }}>⬇ Export CSV</Btn>
        </div>
      </div>
      {loading ? <p style={{ color: '#5a4030' }}>Loading...</p> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 12 }}>
          {DAYS.map(function (dname, di) {
            var dayShifts = shifts.filter(function (s) { return s.day_of_week === di; }).sort(function (a, b) { return ('' + (a.start_time || '')).localeCompare('' + (b.start_time || '')); });
            var date = addDays(monday, di);
            var target = targetsByDay[di] || 0;
            var covered = dayShifts.length;
            return (
              <div key={dname} style={{ background: '#1a1208', border: '1px solid #3a2a12', borderRadius: 10, padding: 12, minHeight: 120 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 8 }}>
                  <div><span style={{ color: '#f5e6c8', fontWeight: 700 }}>{dname}</span> <span style={{ color: '#5a4030', fontSize: 12 }}>{fmtDay(date)}</span></div>
                  <span style={{ fontSize: 11, color: covered >= target ? '#10b981' : '#f59e0b' }}>{covered}/{target}</span>
                </div>
                {dayShifts.map(function (s) {
                  return <div key={s.id} onClick={function () { setModal({ shift: s, dayIndex: di }); }} style={{ background: '#2a1f0f', borderRadius: 6, padding: '6px 8px', marginBottom: 6, cursor: 'pointer' }}>
                    <div style={{ color: '#f5e6c8', fontSize: 13, fontWeight: 600 }}>{s.user_name || userName(s.user_id)}</div>
                    <div style={{ color: '#8a7055', fontSize: 11 }}>{s.job} · {fmtTime(s.start_time)}-{fmtTime(s.end_time)}</div>
                  </div>;
                })}
                <button onClick={function () { setModal({ shift: null, dayIndex: di }); }} style={{ width: '100%', background: 'transparent', border: '1px dashed #3a2a12', borderRadius: 6, padding: '6px', color: '#8a7055', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit' }}>+ Add</button>
              </div>
            );
          })}
        </div>
      )}
      {modal && <ShiftModal shift={modal.shift} users={users} roles={roles} weekStart={weekStart} dayIndex={modal.dayIndex} onClose={function () { setModal(null); }} onSaved={load} />}
    </div>
  );
}

function AvailabilityTab({ users }) {
  const [map, setMap] = useState({});
  const [loading, setLoading] = useState(true);

  const load = useCallback(async function () {
    try {
      const rows = await get('/schedule/availability');
      var m = {};
      (rows || []).forEach(function (r) { m[r.user_id + '|' + r.day_of_week] = !!r.available; });
      setMap(m);
    } catch (e) { console.error(e); } finally { setLoading(false); }
  }, []);
  useEffect(function () { load(); }, [load]);

  async function toggle(userId, di) {
    var key = userId + '|' + di; var next = !map[key];
    setMap(function (p) { var x = Object.assign({}, p); x[key] = next; return x; });
    try { await put('/schedule/availability', { user_id: userId, day_of_week: di, available: next ? 1 : 0, start_time: '', end_time: '' }); }
    catch (e) { console.error(e); }
  }

  if (loading) return <p style={{ color: '#5a4030' }}>Loading...</p>;
  return (
    <div>
      <p style={{ color: '#8a7055', marginBottom: 16 }}>Tap a cell to toggle whether a staff member can work that day. Staff sync from Toast in production; the preview shows your manager accounts.</p>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 560 }}>
          <thead><tr>
            <th style={{ textAlign: 'left', padding: '8px 12px', color: '#c9a96e', fontSize: 12, borderBottom: '1px solid #3a2a12' }}>Staff</th>
            {DAYS.map(function (d) { return <th key={d} style={{ padding: '8px 6px', color: '#c9a96e', fontSize: 12, borderBottom: '1px solid #3a2a12' }}>{d}</th>; })}
          </tr></thead>
          <tbody>
            {users.map(function (u) {
              return <tr key={u.id}>
                <td style={{ padding: '8px 12px', color: '#f5e6c8', fontSize: 14, fontWeight: 600, borderBottom: '1px solid #241a0c' }}>{u.name}</td>
                {DAYS.map(function (d, di) {
                  var on = !!map[u.id + '|' + di];
                  return <td key={d} style={{ padding: 4, textAlign: 'center', borderBottom: '1px solid #241a0c' }}>
                    <button onClick={function () { toggle(u.id, di); }} style={{ width: 36, height: 28, borderRadius: 6, border: '1px solid ' + (on ? '#10b98144' : '#3a2a12'), background: on ? '#10b98122' : '#2a1f0f', color: on ? '#10b981' : '#5a4030', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13 }}>{on ? 'Yes' : '-'}</button>
                  </td>;
                })}
              </tr>;
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function AvailabilityGridModal({ candidateId, name, onClose }) {
  const [grid, setGrid] = useState(null);
  const load = useCallback(function () {
    get('/schedule/candidate-availability/' + candidateId).then(setGrid).catch(function () { });
  }, [candidateId]);
  useEffect(function () { load(); }, [load]);

  function cell(source, day) {
    return (grid && grid.sources[source] && grid.sources[source][day]) || { available: false, start_time: '', end_time: '' };
  }
  async function save(source, day, next) {
    try {
      await put('/schedule/candidate-availability', { candidate_id: candidateId, source: source, day_of_week: day, available: next.available, start_time: next.start_time, end_time: next.end_time });
      load();
    } catch (e) { /* ignore */ }
  }
  const SRC = [['website', 'Website'], ['indeed', 'Indeed'], ['scanned', 'Scanned'], ['final', 'Final']];

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={function (e) { e.stopPropagation(); }} style={{ background: '#1a1208', border: '1px solid #3a2a12', borderRadius: 14, padding: 24, maxWidth: 940, width: '100%', maxHeight: '92vh', overflow: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, color: '#f5e6c8', margin: 0 }}>Availability — {name}</h2>
          <Btn small variant="secondary" onClick={onClose}>Close</Btn>
        </div>
        <p style={{ color: '#8a7055', fontSize: 13, marginTop: 0 }}>Enter what each source said. Days where <strong>Website / Indeed / Scanned</strong> disagree are flagged in red — set the <strong style={{ color: '#10b981' }}>Final</strong> row to the reconciled answer.</p>
        {grid && grid.scanned_text ? <div style={{ background: '#2a1f0f', border: '1px solid #3a2a12', borderRadius: 8, padding: '8px 12px', color: '#f5e6c8', fontSize: 13, marginBottom: 12 }}><span style={{ color: '#8a7055' }}>Scanned sheet (reference): </span>{grid.scanned_text}</div> : null}
        {!grid ? <p style={{ color: '#5a4030' }}>Loading...</p> : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 720 }}>
              <thead><tr>
                <th style={{ textAlign: 'left', padding: '6px 8px', color: '#c9a96e', fontSize: 12 }}>Source</th>
                {DAYS.map(function (dl, di) { var conf = grid.conflicts[di]; return <th key={dl} style={{ padding: '6px 4px', fontSize: 12, color: conf ? '#e63c3c' : '#c9a96e', borderBottom: '1px solid ' + (conf ? '#e63c3c' : '#3a2a12') }}>{dl}{conf ? ' ⚠' : ''}</th>; })}
              </tr></thead>
              <tbody>
                {SRC.map(function (s) {
                  var key = s[0];
                  return (
                    <tr key={key}>
                      <td style={{ padding: '6px 8px', color: key === 'final' ? '#10b981' : '#f5e6c8', fontSize: 13, fontWeight: 600 }}>{s[1]}</td>
                      {DAYS.map(function (dl, di) {
                        var c = cell(key, di);
                        return (
                          <td key={dl} style={{ padding: 3, textAlign: 'center', borderBottom: '1px solid #241a0c', background: grid.conflicts[di] ? 'rgba(230,60,60,0.07)' : 'transparent', verticalAlign: 'top' }}>
                            <input type="checkbox" checked={!!c.available} onChange={function (e) { save(key, di, { available: e.target.checked, start_time: c.start_time, end_time: c.end_time }); }} />
                            {c.available ? (
                              <div style={{ display: 'flex', flexDirection: 'column', gap: 2, marginTop: 2 }}>
                                <input type="time" defaultValue={c.start_time} onBlur={function (e) { if (e.target.value !== c.start_time) save(key, di, { available: true, start_time: e.target.value, end_time: c.end_time }); }} style={{ width: 78, background: '#2a1f0f', border: '1px solid #3a2a12', borderRadius: 4, color: '#f5e6c8', fontSize: 11, fontFamily: 'inherit' }} />
                                <input type="time" defaultValue={c.end_time} onBlur={function (e) { if (e.target.value !== c.end_time) save(key, di, { available: true, start_time: c.start_time, end_time: e.target.value }); }} style={{ width: 78, background: '#2a1f0f', border: '1px solid #3a2a12', borderRadius: 4, color: '#f5e6c8', fontSize: 11, fontFamily: 'inherit' }} />
                              </div>
                            ) : null}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

function ApplicantsTab() {
  const [list, setList] = useState(null);
  const [gridFor, setGridFor] = useState(null);
  useEffect(function () {
    get('/schedule/applicants').then(function (r) { setList(Array.isArray(r) ? r : []); }).catch(function () { setList([]); });
  }, []);

  if (!list) return <p style={{ color: '#5a4030' }}>Loading...</p>;
  if (!list.length) return <p style={{ color: '#5a4030' }}>No applicants in the pipeline yet.</p>;
  return (
    <div>
      <p style={{ color: '#8a7055', marginBottom: 16 }}>Every candidate's full pipeline arc and the availability they gave, side by side. Open <strong style={{ color: '#c9a96e' }}>Reconcile availability</strong> to enter Website / Indeed / scanned answers in a grid and settle conflicts into a final schedule.</p>
      {gridFor && <AvailabilityGridModal candidateId={gridFor.id} name={gridFor.name} onClose={function () { setGridFor(null); }} />}
      {list.map(function (a) {
        return (
          <div key={a.id} style={{ background: '#1a1208', border: '1px solid ' + (a.do_not_rehire ? '#e63c3c' : '#3a2a12'), borderRadius: 12, padding: 16, marginBottom: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
              <span style={{ color: '#f5e6c8', fontSize: 16, fontWeight: 600 }}>{a.name}</span>
              <span style={{ background: stageColor(a.stage) + '22', color: stageColor(a.stage), border: '1px solid ' + stageColor(a.stage) + '44', borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 700, textTransform: 'uppercase' }}>{stageLabel(a.stage)}</span>
              {a.role ? <span style={{ color: '#8a7055', fontSize: 13 }}>{a.role}</span> : null}
              {a.source ? <span style={{ color: '#5a4030', fontSize: 12 }}>· {a.source}</span> : null}
              {a.do_not_rehire ? <span style={{ color: '#e63c3c', fontSize: 11, fontWeight: 700, border: '1px solid #e63c3c44', borderRadius: 4, padding: '2px 8px' }}>DNR</span> : null}
              <span style={{ marginLeft: 'auto' }}><Btn small variant="ghost" onClick={function () { setGridFor({ id: a.id, name: a.name }); }}>Reconcile availability</Btn></span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div>
                <div style={{ color: '#c9a96e', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>Availability</div>
                {a.availability && a.availability.length
                  ? a.availability.map(function (ln, i) { return <div key={i} style={{ color: '#f5e6c8', fontSize: 13, marginBottom: 2 }}>{ln}</div>; })
                  : <div style={{ color: '#5a4030', fontSize: 13 }}>None captured yet.</div>}
              </div>
              <div>
                <div style={{ color: '#c9a96e', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>Pipeline timeline</div>
                {a.timeline && a.timeline.length
                  ? a.timeline.map(function (h, i) {
                    return (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
                        <span style={{ width: 7, height: 7, borderRadius: '50%', background: stageColor(h.stage), flexShrink: 0 }} />
                        <span style={{ color: '#f5e6c8', fontSize: 13 }}>{stageLabel(h.stage)}</span>
                        <span style={{ color: '#5a4030', fontSize: 12, marginLeft: 'auto' }}>{fmtStamp(h.changed_at)}</span>
                      </div>
                    );
                  })
                  : <div style={{ color: '#5a4030', fontSize: 13 }}>No stage history.</div>}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ── Gap Filler: coverage by role×day with availability-based fill recs ───────
function GapFillerTab() {
  const [weekStart, setWeekStart] = useState(ymd(mondayOf(new Date())));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openCell, setOpenCell] = useState(null); // `${role}|${day}`

  const load = useCallback(async function () {
    setLoading(true);
    try { setData(await get('/schedule/coverage?week=' + weekStart)); } catch (e) { console.error(e); } finally { setLoading(false); }
  }, [weekStart]);
  useEffect(function () { load(); }, [load]);

  function shiftWeek(delta) { var d = new Date(weekStart + 'T00:00:00'); d.setDate(d.getDate() + delta * 7); setWeekStart(ymd(d)); }
  async function assign(role, day, person) {
    await post('/schedule/shifts', { user_id: person.id, job: role, week_start: weekStart, day_of_week: day });
    setOpenCell(null); load();
  }
  var monday = new Date(weekStart + 'T00:00:00');
  var roles = data ? (data.roles || []) : [];

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14, flexWrap: 'wrap' }}>
        <Btn small variant="secondary" onClick={function () { shiftWeek(-1); }}>&lt; Prev</Btn>
        <span style={{ color: '#f5e6c8', fontWeight: 600 }}>Week of {fmtDay(monday)} - {fmtDay(addDays(monday, 6))}</span>
        <Btn small variant="secondary" onClick={function () { shiftWeek(1); }}>Next &gt;</Btn>
        <Btn small variant="ghost" onClick={function () { setWeekStart(ymd(mondayOf(new Date()))); }}>This week</Btn>
        {data && <span style={{ marginLeft: 'auto', color: data.total_gap > 0 ? '#f59e0b' : '#10b981', fontWeight: 700, fontSize: 13 }}>{data.total_gap > 0 ? data.total_gap + ' open slot' + (data.total_gap === 1 ? '' : 's') + ' to fill' : '✓ Fully covered'}</span>}
      </div>
      <p style={{ color: '#8a7055', fontSize: 13, marginBottom: 14 }}>Each cell is assigned/target. Click an <span style={{ color: '#f59e0b' }}>amber</span> gap to see who's available to fill it. Targets come from Coverage Targets; availability from the Availability tab.</p>
      {loading ? <p style={{ color: '#5a4030' }}>Loading…</p> : !roles.length ? (
        <p style={{ color: '#5a4030' }}>No coverage targets set yet — add them in the Coverage Targets tab.</p>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 720 }}>
            <thead><tr>
              <th style={{ textAlign: 'left', color: '#8a7055', fontSize: 12, padding: '6px 10px' }}>Role</th>
              {DAYS.map(function (dn, di) { return <th key={dn} style={{ color: '#8a7055', fontSize: 12, padding: '6px 4px', minWidth: 70 }}>{dn}<div style={{ color: '#5a4030', fontWeight: 400 }}>{fmtDay(addDays(monday, di))}</div></th>; })}
            </tr></thead>
            <tbody>
              {roles.map(function (role) {
                return <tr key={role}>
                  <td style={{ color: '#f5e6c8', fontWeight: 600, fontSize: 13, padding: '6px 10px', whiteSpace: 'nowrap' }}>{role}</td>
                  {data.days.map(function (d) {
                    var cell = data.grid[role][d] || { target: 0, assigned: 0, gap: 0 };
                    var key = role + '|' + d;
                    var isGap = cell.gap > 0;
                    var noTarget = cell.target === 0;
                    return <td key={d} style={{ padding: 3, textAlign: 'center' }}>
                      <button onClick={function () { if (isGap) setOpenCell(openCell === key ? null : key); }}
                        style={{ width: '100%', cursor: isGap ? 'pointer' : 'default', border: '1px solid ' + (isGap ? '#f59e0b66' : noTarget ? '#2a1f0f' : '#10b98144'), background: openCell === key ? '#f59e0b33' : isGap ? '#f59e0b18' : noTarget ? 'transparent' : '#10b98114', color: noTarget ? '#5a4030' : isGap ? '#f59e0b' : '#10b981', borderRadius: 6, padding: '8px 4px', fontSize: 13, fontWeight: 700, fontFamily: 'inherit' }}>
                        {noTarget ? '–' : cell.assigned + '/' + cell.target}
                      </button>
                    </td>;
                  })}
                </tr>;
              })}
            </tbody>
          </table>
        </div>
      )}
      {openCell && data && (function () {
        var parts = openCell.split('|'); var role = parts[0]; var d = parseInt(parts[1], 10);
        var recs = ((data.recommendations[role] && data.recommendations[role][d]) || []).slice().sort(function (a, b) { return String(a.name).localeCompare(String(b.name), undefined, { sensitivity: 'base' }); });
        return <div style={{ background: '#1a1208', border: '1px solid #f59e0b44', borderRadius: 10, padding: 16, marginTop: 16 }}>
          <div style={{ color: '#f5e6c8', fontWeight: 700, marginBottom: 4 }}>{role} · {DAYS[d]} — available to fill</div>
          <p style={{ color: '#8a7055', fontSize: 12, marginBottom: 12 }}>People whose role matches and who marked themselves available {DAYS[d]}, not already scheduled that day.</p>
          {!recs.length ? <p style={{ color: '#5a4030', fontSize: 13 }}>No available {role} for {DAYS[d]}. Check the Availability tab, or this role's onboarding pool.</p> : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {recs.map(function (p) {
                return <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#2a1f0f', borderRadius: 8, padding: '10px 14px' }}>
                  <span style={{ color: '#f5e6c8', fontWeight: 600, fontSize: 14, flex: 1 }}>{p.name} {p.kind === 'candidate' && <span style={{ color: '#c9a96e', fontSize: 11, fontWeight: 400 }}>· onboarding</span>}</span>
                  {p.kind === 'staff'
                    ? <Btn small onClick={function () { assign(role, d, p); }}>Assign</Btn>
                    : <span style={{ color: '#8a7055', fontSize: 12 }}>Create login to schedule</span>}
                </div>;
              })}
            </div>
          )}
        </div>;
      })()}
    </div>
  );
}

export function ScheduleView() {
  const [tab, setTab] = useState('targets');
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [targetsByDay, setTargetsByDay] = useState({});

  useEffect(function () {
    get('/users').then(function (u) { setUsers(Array.isArray(u) ? u : []); }).catch(function () {});
    get('/schedule/targets').then(function (rows) {
      var rset = {}; var byDay = {};
      (rows || []).forEach(function (r) { rset[r.role] = true; byDay[r.day_of_week] = (byDay[r.day_of_week] || 0) + (r.target || 0); });
      setRoles(orderRoles(Object.keys(rset))); setTargetsByDay(byDay);
    }).catch(function () {});
  }, []);

  var tabs = [['applicants', 'Applicants'], ['targets', 'Coverage Targets'], ['shifts', 'Weekly Schedule'], ['gaps', 'Gap Filler'], ['availability', 'Availability']];

  return (
    <div>
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, color: '#f5e6c8', marginBottom: 6 }}>Schedule</h2>
      <p style={{ color: '#8a7055', marginBottom: 18 }}>Coverage targets, weekly shifts, and staff availability - all in one place.</p>
      <div style={{ display: 'flex', gap: 4, marginBottom: 22, borderBottom: '1px solid #3a2a12' }}>
        {tabs.map(function (t) {
          var active = tab === t[0];
          return <button key={t[0]} onClick={function () { setTab(t[0]); }} style={{ background: 'transparent', border: 'none', borderBottom: '2px solid ' + (active ? '#c9a96e' : 'transparent'), color: active ? '#c9a96e' : '#8a7055', fontWeight: active ? 700 : 400, fontSize: 14, padding: '10px 16px', cursor: 'pointer', fontFamily: 'inherit', marginBottom: -1 }}>{t[1]}</button>;
        })}
      </div>
      {tab === 'applicants' && <ApplicantsTab />}
      {tab === 'targets' && <TargetsTab />}
      {tab === 'shifts' && <ShiftsTab users={users} roles={roles} targetsByDay={targetsByDay} />}
      {tab === 'gaps' && <GapFillerTab />}
      {tab === 'availability' && <AvailabilityTab users={users} />}
    </div>
  );
}
